import React from 'react'

import PositionsTable from '../containers/PositionsTable'
import PositionsTablePending from '../containers/PositionsTablePending'
import HistoryTable from '../containers/HistoryTable'
import { Translate } from 'react-redux-i18n'
import Spinner from './Spinner'
import { AppMode } from '../types'

export interface Props {
  accountLoaded: boolean
  opened: boolean
  positionsCount: number
  appMode: AppMode
  tradeOperationEnabled: boolean
  onCloseAllTrades: () => void
  onToggleMenu: () => void
  onSelectPosition: (order: number, expanded?: boolean) => void
}

const PositionsPane = (props: Props) => {
  return <PositionsPaneContent {...props} />
}

class PositionsPaneContent extends React.Component<Props, {}> {
  public render() {
    const {
      appMode,
      // positionsCount,
      accountLoaded,
      // opened,
      onToggleMenu,
      // onCloseAllTrades,
      // tradeOperationEnabled,
    } = this.props
    const { table, label } =
      appMode === 'positions'
        ? { table: <PositionsTable />, label: 'openPositions' }
        : appMode === 'orders'
        ? { table: <PositionsTablePending />, label: 'pendingOrders' }
        : { table: <HistoryTable />, label: 'tradeHistory' }
    return (
      <>
        <div className="select-assets__header d-flex justify-content-between align-items-center">
          <div className="hidden-wrapper__title">
            <Translate value={label} />
          </div>
          <button onClick={onToggleMenu} className="btn close_btn" data-cy="closePositionPane">
            <i className="icon-close" />
          </button>
        </div>
        <div id="positionsPaneContent" className="hidden-wrapper__content">
          {!accountLoaded ? <Spinner /> : table}
        </div>
        {/* {positionsCount && appMode==='open'
                    ?   <div className="justify-content-end align-items-center d-flex mb-2 pb-1 px-3">
                            <button onClick={onCloseAllTrades} className="btn black_button" disabled={!tradeOperationEnabled} data-cy="closeAll">
                                <Translate value={"closeAll"}/> <span>({positionsCount})</span>
                            </button>
                        </div>
                    :   ""} */}
      </>
    )
  }
}

export default PositionsPane
